import React from 'react';
import {Checkbox, FormControlLabel, Link, Typography} from '@mui/material';
import {LegalDocumentsDto} from '../../shared/services/legal.service';

interface Props {
  documents: LegalDocumentsDto | null;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * SQ-419: the one checkbox that covers both documents. Each is linked (a new
 * tab, so the form keeps what was typed) to be read before agreeing.
 */
const LegalAgreementCheckbox: React.FC<Props> = ({documents, checked, onChange, disabled}) => {
  const link = (path: string | undefined, fallback: string, label: string) => (
    <Link href={path ?? fallback} target="_blank" rel="noopener" onClick={(e) => e.stopPropagation()}>
      {label}
    </Link>
  );
  return (
    <FormControlLabel
      sx={{mt: 1, alignItems: 'flex-start'}}
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled || !documents}
          inputProps={{'aria-label': 'I agree to the Terms of Service and Privacy Policy'}}
          sx={{pt: 0.5}}
        />
      }
      label={
        <Typography variant="body2" sx={{pt: 0.75}}>
          I agree to the{' '}
          {link(documents?.terms.path, '/documents/terms-of-service.html', 'Terms of Service')}
          {' '}and the{' '}
          {link(documents?.privacy.path, '/documents/privacy-policy.html', 'Privacy Policy')}.
        </Typography>
      }
    />
  );
};

export default LegalAgreementCheckbox;
